import type { IExercise } from '../exercises';

export const KAISHENG_EPISODE_02_MATERIALS: IExercise[] = [
  {
    "id": "course-20261008-ksw-collection-02-01",
    "name": "热身_伟大者伸展",
    "bodyPart": "warmup",
    "equipment": "bodyweight",
    "subCategory": "general",
    "tips": ["核心收紧，控制动作节奏", "全程保持稳定"],
    "sets": 2,
    "reps": "每侧5",
    "rpe": 3,
    "restSeconds": 20,
    "isBodyweight": true,
    "isStretch": false,
    "isWarmup": true,
    "difficulty": "beginner",
    "targetMuscles": ["目标拉伸肌群"],
    "demoUrl": "/media/collections-20261008/demos/f9cd6e5c1949b98df969417b.mp4",
    "videoUrl": "/media/collections-20261008/videos/f6accd53aa402141b5459a90.mp4",
    "source": "凯圣王合集 · 第2期",
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-ksw-collection-02-02",
    "name": "热身_弹力带绕肩",
    "bodyPart": "warmup",
    "equipment": "resistance-band",
    "subCategory": "general",
    "tips": ["弹力带两端握手上，直臂前后绕肩", "动作缓慢流畅，激活肩关节活动度"],
    "sets": 2,
    "reps": "15",
    "rpe": 3,
    "restSeconds": 30,
    "isBodyweight": false,
    "isWarmup": true,
    "difficulty": "beginner",
    "targetMuscles": ["全身激活肌群"],
    "source": "凯圣王合集 · 第2期",
    "demoUrl": "/media/collections-20261008/demos/e9f1b763226fc409b5bddb90.mp4",
    "videoUrl": "/media/collections-20261008/videos/e8e8f6a226a095ad1dc11611.mp4",
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-ksw-collection-02-03",
    "name": "热身_拉伸对抗",
    "bodyPart": "warmup",
    "equipment": "bodyweight",
    "subCategory": "general",
    "tips": ["拉伸与对抗交替", "增加关节活动度"],
    "sets": 2,
    "reps": "15次",
    "rpe": 4,
    "restSeconds": 30,
    "isBodyweight": true,
    "isWarmup": true,
    "demoUrl": "/media/collections-20261008/demos/7a3550b347013a682dde8a27.mp4",
    "videoUrl": "/media/collections-20261008/videos/a7ed4ac91f5c2979b59443ca.mp4",
    "targetMuscles": ["全身激活肌群"],
    "difficulty": "beginner",
    "source": "凯圣王合集 · 第2期",
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-ksw-collection-02-04",
    "name": "热身_胸椎屈曲激活",
    "bodyPart": "warmup",
    "equipment": "bodyweight",
    "subCategory": "general",
    "tips": ["跪位或站姿，做胸椎屈曲-伸展", "打开胸椎活动度，提升划船动作质量"],
    "sets": 2,
    "reps": "10",
    "rpe": 2,
    "restSeconds": 20,
    "isBodyweight": true,
    "isWarmup": true,
    "difficulty": "beginner",
    "targetMuscles": ["全身激活肌群"],
    "source": "凯圣王合集 · 第2期",
    "demoUrl": "/media/collections-20261008/demos/af389bcdefdb10df0de852bb.mp4",
    "videoUrl": "/media/collections-20261008/videos/3a14215ac9f8334d43dc1caf.mp4",
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-ksw-collection-02-05",
    "name": "热身_胸椎本体感受激活",
    "bodyPart": "warmup",
    "equipment": "bodyweight",
    "subCategory": "shoulder",
    "tips": ["配合呼吸做胸椎旋转+稳定", "提升胸椎本体感受，减少腰背代偿"],
    "sets": 2,
    "reps": "10",
    "rpe": 2,
    "restSeconds": 20,
    "isBodyweight": true,
    "isWarmup": true,
    "difficulty": "beginner",
    "targetMuscles": ["全身激活肌群"],
    "source": "凯圣王合集 · 第2期",
    "demoUrl": "/media/collections-20261008/demos/4903771892268466e2e4c957.mp4",
    "videoUrl": "/media/collections-20261008/videos/64bae01bf9cf1713af1c4785.mp4",
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-ksw-collection-02-06",
    "name": "单手钢线下拉",
    "bodyPart": "back",
    "equipment": "cable",
    "subCategory": "lat",
    "tips": ["单手持把手，挺胸沉肩", "下压时感受背阔肌收缩，顶峰停顿 1 秒"],
    "sets": 3,
    "reps": "12",
    "rpe": 8,
    "restSeconds": 75,
    "isBodyweight": false,
    "difficulty": "advanced",
    "targetMuscles": ["背阔肌", "大圆肌"],
    "source": "凯圣王合集 · 第2期",
    "demoUrl": "/media/collections-20261008/demos/def837bdd238cabb1bcb755e.mp4",
    "videoUrl": "/media/collections-20261008/videos/d953b09d7276c61bbc4d53f5.mp4",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-ksw-collection-02-07",
    "name": "单手器械划船",
    "bodyPart": "back",
    "equipment": "machine",
    "subCategory": "row",
    "tips": ["单手对握把手，身体稳定不晃动", "拉至腰侧，感受中背收缩"],
    "sets": 3,
    "reps": "10",
    "rpe": 8,
    "restSeconds": 75,
    "isBodyweight": false,
    "difficulty": "advanced",
    "targetMuscles": ["斜方肌中下部", "菱形肌", "背阔肌"],
    "source": "凯圣王合集 · 第2期",
    "demoUrl": "/media/collections-20261008/demos/54cecfc0c07b665da0186e9f.mp4",
    "videoUrl": "/media/collections-20261008/videos/2baf4c0b60fd1c48354c2943.mp4",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-ksw-collection-02-08",
    "name": "对握下拉",
    "bodyPart": "back",
    "equipment": "cable",
    "subCategory": "lat",
    "tips": ["拉至胸上沿", "挤压背阔肌"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 75,
    "isBodyweight": false,
    "demoUrl": "/media/collections-20261008/demos/6a9f809d33f7113248d6dc90.mp4",
    "videoUrl": "/media/collections-20261008/videos/9e9abcbe9f4c0eb961df0122.mp4",
    "targetMuscles": ["背阔肌", "肱二头肌"],
    "difficulty": "beginner",
    "source": "凯圣王合集 · 第2期",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-ksw-collection-02-09",
    "name": "开肘拉",
    "bodyPart": "back",
    "equipment": "cable",
    "subCategory": "thickness",
    "tips": ["开肘位绳索划船，侧重后束和中背", "拉至下巴位置，肩胛骨充分后缩"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": false,
    "difficulty": "advanced",
    "targetMuscles": ["菱形肌", "斜方肌中部", "三角肌后束"],
    "source": "凯圣王合集 · 第2期",
    "demoUrl": "/media/collections-20261008/demos/fb800a68052f04bea9cf80e0.mp4",
    "videoUrl": "/media/collections-20261008/videos/a26a92007276f21882a0ea59.mp4",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-ksw-collection-02-10",
    "name": "钢线弯举",
    "bodyPart": "arms",
    "equipment": "cable",
    "subCategory": "biceps",
    "tips": ["身体稳定，大臂贴身体两侧", "弯举时感受二头肌顶峰收缩，下放控制"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": false,
    "difficulty": "advanced",
    "targetMuscles": ["肱二头肌"],
    "source": "凯圣王合集 · 第2期",
    "demoUrl": "/media/collections-20261008/demos/36d1965541806af54957f8a1.mp4",
    "videoUrl": "/media/collections-20261008/videos/e4ee5b0c642003ee0a931277.mp4",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
];
